document.addEventListener('DOMContentLoaded', function() {
    
    function initializeShippingCalculator() {
        var shippingZip = document.querySelector('#shipping-calculator-input');
        var shippingCalcButton = document.querySelector('.shippingCalcButton');
        var shippingMessage = document.querySelector('.shipping-message');
        
        if (!shippingZip || !shippingCalcButton || !shippingMessage) {
            return false;
        }

        function getProductRoot() {
            return shippingZip.closest('product-info') || document;
        }

        function getCurrentVariantId() {
            var variantInput = getProductRoot().querySelector('product-form.product-form input[name="id"]');
            if (!variantInput) return null;
            return variantInput.value || variantInput.getAttribute('value');
        }
        
        function loadSavedCEP() {
            var savedCEP = localStorage.getItem('cabralab_shipping_cep');
            if (savedCEP && savedCEP.length === 8) {
                var formattedCEP = savedCEP.replace(/(\d{5})(\d)/, '$1-$2');
                shippingZip.value = formattedCEP;
            }
        }
        
        function saveCEP(cep) {
            var cleanCEP = cep.replace(/\D/g, '');
            if (cleanCEP.length === 8) {
                localStorage.setItem('cabralab_shipping_cep', cleanCEP);
            }
        }
        
        loadSavedCEP();
        
        shippingZip.addEventListener('input', function(e) {
            var value = e.target.value.replace(/\D/g, '');
            if(value.length <= 8) {
                value = value.replace(/(\d{5})(\d)/, '$1-$2');
                e.target.value = value;
            }
        });
        
        shippingCalcButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            var zipValue = shippingZip.value.replace(/\D/g, '');
            
            if(zipValue.length !== 8) {
                shippingMessage.innerHTML = '<div style="color: #E91E63;">Por favor, insira um CEP válido com 8 dígitos.</div>';
                return;
            }
            
            var variantId = getCurrentVariantId();
            
            if(!variantId) {
                shippingMessage.innerHTML = '<div style="color: #E91E63;">Por favor, selecione uma variante do produto.</div>';
                return;
            }
            
            
            shippingCalcButton.innerHTML = 'Calculando...';
            shippingCalcButton.disabled = true;
            shippingMessage.innerHTML = '<div style="color: #666; font-style: italic;">Calculando frete...</div>';
            
            var productData = getProductData();
            
            if (!productData) {
                shippingMessage.innerHTML = '<div style="color: #E91E63;">Erro: Dados do produto não encontrados.</div>';
                resetButton();
                return;
            }
            
            saveCEP(zipValue);
            
            calculateShippingWithProductData(zipValue, productData, variantId);
        });
        
        shippingZip.addEventListener('keypress', function(e) {
            if(e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                shippingCalcButton.click();
            }
        });
        
        function getProductData() {
            try {
                var productData = null;
                
                var productScript = document.querySelector('script[type="application/json"][data-product-json]');
                if (productScript) {
                    productData = JSON.parse(productScript.textContent);
                    return productData;
                }
                
                if (window.product) {
                    productData = window.product;
                    return productData;
                }
                
                var variantScript = document.querySelector('textarea[data-variant-json]');
                if (variantScript) {
                    var variants = JSON.parse(variantScript.textContent);
                    var variantId = getCurrentVariantId();
                    if (variantId) {
                        var selectedVariant = variants.find(v => v.id == variantId);
                        if (selectedVariant) {
                            return selectedVariant;
                        }
                    }
                }
                
                if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.product) {
                    productData = Shopify.theme.product;
                    return productData;
                }
                
                return null;
            } catch (e) {
                return null;
            }
        }
        
        function getSelectedQuantity() {
            var root = getProductRoot();
            var buyMoreRadio = root.querySelector('.buy-more-radio:checked');
            if (buyMoreRadio) {
                var qty = parseInt(buyMoreRadio.value, 10);
                if (!isNaN(qty) && qty > 0) return qty;
            }

            var qtyInput = root.querySelector('.product-form__quantity .quantity__input');

            if (qtyInput) {
                var qty = parseInt(qtyInput.value, 10);
                if (!isNaN(qty) && qty > 0) return qty;
            }

            return 1;
        }

        function calculateShippingWithProductData(zipValue, productData, variantId) {
            getShopifyShippingRates(zipValue, variantId);
        }
        
        var originalCartState = null;
        
        function saveCartState() {
            return fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    originalCartState = cart;
                    return cart;
                })
                .catch(error => {
                    return null;
                });
        }
        
        function restoreCartState() {
            if (!originalCartState) {
                return Promise.resolve();
            }
            
            return fetch('/cart/clear.js', { method: 'POST' })
                .then(() => {
                if (originalCartState.items && originalCartState.items.length > 0) {
                        var addPromises = originalCartState.items.map(item => {
                            return fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    id: item.variant_id,
                                    quantity: item.quantity,
                                    properties: item.properties
                                })
                            }).catch(error => {});
                        });
                        return Promise.all(addPromises);
                    }
                    return Promise.resolve();
                })
                .then(() => {
                    originalCartState = null;
                })
                .catch(error => {});
        }
        
        function displayShippingRates(rates) {
            var root = document.documentElement;
            var buttonColor = getComputedStyle(root).getPropertyValue('--color-button').trim();
            var foregroundColor = getComputedStyle(root).getPropertyValue('--color-foreground').trim();
            var backgroundColor = getComputedStyle(root).getPropertyValue('--color-background').trim();
            
            var buttonColorRGB = buttonColor.split(',').map(v => v.trim()).join(', ');
            var foregroundColorRGB = foregroundColor.split(',').map(v => v.trim()).join(', ');
            var backgroundColorRGB = backgroundColor.split(',').map(v => v.trim()).join(', ');
            
            var messageHtml = '<div style="background: rgba(' + backgroundColorRGB + ', 0.5); border: 1px solid rgba(' + foregroundColorRGB + ', 0.1); border-radius: 6px; padding: 15px; margin-top: 10px;">';
            
            for (var i = 0; i < rates.length; i++) {
                var element = rates[i];
                var isLastItem = (i === rates.length - 1);
                
                var deliveryInfo = '';
                var deliveryPrice = '';
                
                if (element.description) {
                    deliveryInfo = element.description;
                }
                else if (element.delivery_days && element.delivery_days.length > 0) {
                    if (element.delivery_days[0] == 1) {
                        deliveryInfo = '1 dia útil';
                    } else {
                        deliveryInfo = element.delivery_days[0] + ' dias úteis';
                    }
                }
                
                var priceValue = parseFloat(element.price);
                if (priceValue === 0 || element.price === "0.00" || element.price === 0 || element.price === "0") {
                    deliveryPrice = '<span style="color: rgb(' + buttonColorRGB + '); font-weight: 700;">GRÁTIS</span>';
                } else {
                    deliveryPrice = 'R$ ' + element.price.replace('.', ',');
                }
                
                var borderStyle = isLastItem ? '' : 'border-bottom: 1px solid rgba(' + foregroundColorRGB + ', 0.1);';
                
                messageHtml += '<div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; ' + borderStyle + '">';
                messageHtml += '<div style="display: flex; align-items: center;">';
                messageHtml += '<span style="font-weight: 500; color: rgb(' + foregroundColorRGB + ');">' + (element.name || 'Frete') + '</span>';
                if(deliveryInfo) {
                    messageHtml += '<span style="margin-left: 8px; color: rgba(' + foregroundColorRGB + ', 0.6); font-size: 13px;">(' + deliveryInfo + ')</span>';
                }
                messageHtml += '</div>';
                if (priceValue === 0 || element.price === "0.00" || element.price === 0 || element.price === "0") {
                    messageHtml += deliveryPrice;
                } else {
                    messageHtml += '<span style="font-weight: 600; color: rgb(' + buttonColorRGB + ');">' + deliveryPrice + '</span>';
                }
                messageHtml += '</div>';
            }
            
            messageHtml += '</div>';
            shippingMessage.innerHTML = messageHtml;
        }
        
        function resetButton() {
            shippingCalcButton.innerHTML = 'Calcular frete';
            shippingCalcButton.disabled = false;
        }
        
        function getAddressFromCEP(cep) {
            return fetch('https://viacep.com.br/ws/' + cep + '/json/')
                .then(response => response.json())
                .then(data => {
                    if (data.erro) {
                        throw new Error('CEP não encontrado');
                    }
                    return {
                        street: data.logradouro || 'Rua',
                        neighborhood: data.bairro || 'Centro',
                        city: data.localidade || 'São Paulo',
                        state: data.uf || 'SP'
                    };
                })
                .catch(error => {
                    return {
                        street: 'Rua',
                        neighborhood: 'Centro',
                        city: 'São Paulo',
                        state: 'SP'
                    };
                });
        }
        
        function cartIsReady(cart, variantId, quantity) {
            var items = cart && cart.items ? cart.items : [];
            if (items.length !== 1) return false;
            return String(items[0].variant_id) === String(variantId) && items[0].quantity === quantity;
        }

        function waitForCartReady(variantId, quantity, maxAttempts, attempt) {
            attempt = attempt || 0;
            maxAttempts = maxAttempts || 10;
            
            return fetch('/cart.js')
                .then(function(response) {
                    return response.json();
                })
                .then(function(cart) {
                    if (cartIsReady(cart, variantId, quantity) || attempt >= maxAttempts) {
                        return cart;
                    }
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            waitForCartReady(variantId, quantity, maxAttempts, attempt + 1).then(resolve);
                        }, 200);
                    });
                })
                .catch(function() {
                    if (attempt >= maxAttempts) {
                        return null;
                    }
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            waitForCartReady(variantId, quantity, maxAttempts, attempt + 1).then(resolve);
                        }, 200);
                    });
                });
        }
        
        function getShopifyShippingRates(zipValue, variantId) {
            var addressData = null;
            var selectedQuantity = getSelectedQuantity();
            
            Promise.all([
                saveCartState(),
                getAddressFromCEP(zipValue)
            ])
                .then(function(results) {
                    addressData = results[1];
                    return fetch('/cart/clear.js', { method: 'POST' });
                })
                .then(function() {
                    return fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'xmlhttprequest'
                        },
                        body: JSON.stringify({
                            'id': parseInt(variantId),
                            'quantity': selectedQuantity,
                            'properties': {
                                '_shipping_calc': 'true'
                            }
                        })
                    });
                })
                .then(function(response) {
                    return response.json().then(function(data) {
                        if (!response.ok || data.status) {
                            throw new Error('add-failed');
                        }
                        return data;
                    });
                })
                .then(function() {
                    return waitForCartReady(parseInt(variantId, 10), selectedQuantity);
                })
                .then(function(cart) {
                    if (!cartIsReady(cart, parseInt(variantId, 10), selectedQuantity)) {
                        throw new Error('cart-mismatch');
                    }

                    var url = '/cart/shipping_rates.json?' + new URLSearchParams({
                        'shipping_address[country]': 'Brazil',
                        'shipping_address[province]': addressData.state,
                        'shipping_address[zip]': zipValue,
                        'shipping_address[city]': addressData.city,
                        'shipping_address[address1]': addressData.street,
                        'shipping_address[address2]': addressData.neighborhood
                    });
                    
                    return fetch(url);
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(result) {
                    return restoreCartState().then(function() {
                        return result;
                    });
                })
                .then(function(result) {
                    if(result.shipping_rates && result.shipping_rates.length) {
                        displayShippingRates(result.shipping_rates);
                    } else {
                        shippingMessage.innerHTML = '<div style="color: #E91E63;">Nenhuma opção de frete encontrada para este CEP.</div>';
                    }
                    
                    resetButton();
                })
                .catch(function(error) {
                    restoreCartState().then(function() {
                        shippingMessage.innerHTML = '<div style="color: #E91E63;">Erro ao calcular frete. Por favor, tente novamente.</div>';
                        resetButton();
                    });
                });
        }
        
        return true;
    }
    
    if (!initializeShippingCalculator()) {
        setTimeout(function() {
            if (!initializeShippingCalculator()) {
                setTimeout(initializeShippingCalculator, 500);
            }
        }, 200);
    }
});

